/**
 * /app/resolutions — tenant-wide entry into the resolutions list.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/resolutions/')({
  component: () => (
    <TrustScopedLanding
      suffix="resolutions"
      eyebrow="Resolutions"
      title="Resolutions"
      emptyHelp="Resolutions are the formal decisions of your trustees: appointments, distributions, investment changes, and so on. They appear here once a trust is onboarded and trustees begin signing."
    />
  ),
});
